import Vue from 'vue'

import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
Vue.component('fa', FontAwesomeIcon)

// import everything for convenience - makes the build 4.4MB bigger
// use this during development / when adding new icons

import { fab } from '@fortawesome/free-brands-svg-icons'
library.add(fab)
import { fas } from '@fortawesome/free-solid-svg-icons'
library.add(fas)
import { far } from '@fortawesome/free-regular-svg-icons'
library.add(far)
// import { fal } from '@fortawesome/pro-light-svg-icons'
// library.add(fal)


import { faImdb } from '@fortawesome/free-brands-svg-icons'
library.add(faImdb)

// import { faExternalLink } from '@fortawesome/pro-light-svg-icons'
// library.add(faExternalLink)

// import { faLongArrowDown, faLongArrowUp, faUndo, faSlidersH, faFilm, faLanguage, faFlag } from '@fortawesome/pro-regular-svg-icons'
// library.add(faLongArrowDown, faLongArrowUp, faUndo, faSlidersH, faFilm, faLanguage, faFlag)

// genres
// import { faCrosshairs, faMars, faMapSigns, faPalette, faBook, faLaughBeam, faUserSecret, faGraduationCap, faGem, faUsers, faWandMagic, faMask, faGameBoard, faSwords, faScarecrow, faHeadphones, faMusic, faCrow, faList, faHome, faHeart, faRocket, faCut, faFutbol, faComments, faKnifeKitchen, faFighterJet, faHorseHead } from '@fortawesome/pro-regular-svg-icons'
// library.add(faCrosshairs, faMars, faMapSigns, faPalette, faBook, faLaughBeam, faUserSecret, faGraduationCap, faGem, faUsers, faWandMagic, faMask, faGameBoard, faSwords, faScarecrow, faHeadphones, faMusic, faCrow, faList, faHome, faHeart, faRocket, faCut, faFutbol, faComments, faKnifeKitchen, faFighterJet, faHorseHead)

// tabs
// import { faBookmark, faEye, faFilter, faDatabase, faQuestion } from '@fortawesome/pro-regular-svg-icons'
// library.add(faBookmark, faEye, faFilter, faDatabase, faQuestion)
// import { faChevronDoubleRight, faChevronDoubleLeft, faFilmAlt, faSearch, faSort } from '@fortawesome/pro-solid-svg-icons'
// library.add(faChevronDoubleRight, faChevronDoubleLeft, faFilmAlt, faSearch, faSort)
